<template>
  <v-row class="tabela-seleciona-pessoa__layout">
    <v-dialog v-model="formEditPessoa" persistent max-width="500">
      <v-card class="tabela-seleciona-pessoa__dialogo">
        <v-form @submit.prevent="enviaUpdatePessoa()">
          <v-card-title class="tabela-seleciona-pessoa__dialogo-titulo">
            <v-avatar size="38" class="tabela-seleciona-pessoa__icone mr-3">
              <v-icon color="primary" size="20"
                >mdi-account-edit-outline</v-icon
              >
            </v-avatar>
            {{ $t("Editar_pessoa") }}
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="12">
                <v-text-field
                  type="number"
                  :label="$t('Quantidade')"
                  v-can="'ROLE_Pessoa_Update'"
                  class="purple-input"
                  min="1"
                />
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-actions class="tabela-seleciona-pessoa__dialogo-acoes">
            <v-spacer></v-spacer>

            <v-btn
              height="39"
              class="
                font-weight-bold
                text-capitalize
                btn-ls btn-secondary
                bg-gradient-light
                py-3
                px-6
              "
              @click="formEditPessoa = false"
            >
              {{ $t("Cancelar") }}
            </v-btn>

            <v-btn
              class="
                ma-1
                font-weight-bold
                text-none
                btn-primary
                bg-gradient-primary
                py-3
                px-6
                ms-3
              "
              height="39"
            >
              {{ $t("Adicionar") }}
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-col cols="12" md="12" class="tabela-seleciona-pessoa__coluna">
      <v-card class="tabela-seleciona-pessoa" outlined elevation="0">
        <div class="tabela-seleciona-pessoa__cabecalho">
          <div class="tabela-seleciona-pessoa__identificacao">
            <v-avatar size="42" class="tabela-seleciona-pessoa__icone">
              <v-icon color="primary">mdi-account-search-outline</v-icon>
            </v-avatar>
            <div class="min-width-0">
              <h5 class="font-weight-bold text-h5 text-typo mb-1">
                {{ translatedTitle }}
              </h5>
              <p class="text-sm text-body mb-0">
                {{ $t("Clique_para_selecionar") }}
              </p>
            </div>
          </div>

          <div class="tabela-seleciona-pessoa__indicadores" aria-live="polite">
            <v-chip v-if="pessoaSelecionada" small outlined color="success">
              <v-icon left small>mdi-check-circle-outline</v-icon>
              {{ $t("Selecionado") }}
            </v-chip>
            <v-chip v-if="showResultCount" small outlined color="primary">
              <v-icon left small>mdi-account-multiple-outline</v-icon>
              {{ totalItems }} {{ $t("Pessoas") }}
            </v-chip>
          </div>
        </div>

        <div class="tabela-seleciona-pessoa__filtros" role="search">
          <v-row class="tabela-seleciona-pessoa__campos">
            <v-col cols="12" :md="editar ? 5 : 7">
              <v-text-field
                ref="nomeCpfInput"
                v-model.trim="filters.nomeCpf"
                hide-details
                class="
                  input-style
                  font-size-input
                  text-light-input
                  placeholder-light
                  input-icon
                "
                dense
                flat
                filled
                solo
                clearable
                height="39"
                :label="$t('Nome e CPF')"
                :placeholder="$t('Nome e CPF')"
                :disabled="loading"
                :aria-label="$t('Nome e CPF')"
                @keydown="onSearchShortcut"
              >
                <template slot="prepend-inner">
                  <v-icon color="#8392ab" size="18">
                    mdi-account-search-outline
                  </v-icon>
                </template>
              </v-text-field>
            </v-col>

            <v-col
              v-if="editar"
              cols="12"
              md="2"
              class="tabela-seleciona-pessoa__modo-edicao"
            >
              <v-switch
                v-model="itemsPerPage"
                :false-value="1"
                :true-value="4"
                hide-details
                inset
                class="mt-0"
                @change="onModoEdicaoChange"
              >
                <template v-slot:label>
                  <span class="text-sm font-weight-bold">
                    {{ $t("Editar") }}
                  </span>
                </template>
              </v-switch>
            </v-col>

            <v-col
              cols="12"
              md="5"
              class="tabela-seleciona-pessoa__acoes-busca"
            >
              <v-btn
                type="button"
                height="39"
                :loading="loading"
                :disabled="!hasFilters"
                class="
                  tabela-seleciona-pessoa__botao-busca
                  font-weight-bold
                  text-none
                  btn-primary
                  bg-gradient-primary
                  px-5
                "
                @click="onSearch"
              >
                <v-icon left size="18">mdi-magnify</v-icon>
                {{ $t("Buscar") }}
              </v-btn>
              <v-btn
                type="button"
                height="39"
                :disabled="(!hasFilters && !searched) || loading"
                class="
                  tabela-seleciona-pessoa__botao-busca
                  font-weight-bold
                  text-none
                  btn-ls btn-secondary
                  bg-gradient-light
                  px-4
                "
                @click="onClear"
              >
                <v-icon left size="18">mdi-filter-remove-outline</v-icon>
                {{ $t("Limpar") }}
              </v-btn>
            </v-col>
          </v-row>

          <div class="tabela-seleciona-pessoa__dica">
            <v-icon size="15" color="#8392ab" class="mr-1">
              mdi-keyboard-outline
            </v-icon>
            Ctrl/⌘ + Shift + Enter
          </div>
        </div>

        <v-alert
          v-if="errorMessage"
          type="error"
          dense
          text
          border="left"
          class="tabela-seleciona-pessoa__erro"
        >
          <div class="d-flex flex-wrap align-center justify-space-between">
            <span>{{ errorMessage }}</span>
            <v-btn
              text
              small
              type="button"
              color="error"
              :loading="loading"
              @click="onSearch(false)"
            >
              {{ $t("Tentar_novamente") }}
            </v-btn>
          </div>
        </v-alert>

        <section
          v-if="pessoaSelecionada"
          class="tabela-seleciona-pessoa__selecionada"
          aria-live="polite"
        >
          <div class="tabela-seleciona-pessoa__selecionada-avatar">
            <v-avatar size="40">
              <span>{{ iniciaisPessoaSelecionada }}</span>
            </v-avatar>
            <span class="tabela-seleciona-pessoa__selecionada-check">
              <v-icon color="white" size="11">mdi-check</v-icon>
            </span>
          </div>
          <div class="tabela-seleciona-pessoa__selecionada-conteudo">
            <strong>{{ pessoaSelecionada.nome }}</strong>
            <span v-if="pessoaSelecionada.cpf">
              <v-icon size="14">mdi-card-account-details-outline</v-icon>
              {{ pessoaSelecionada.cpf | VMask("###.###.###-##") }}
            </span>
          </div>
          <v-chip small outlined color="success" class="font-weight-bold">
            {{ $t("Selecionado") }}
          </v-chip>
        </section>

        <v-data-table
          v-if="searched || loading"
          v-model="pessoa"
          :headers="headers"
          :items="pessoas"
          :items-per-page="itemsPerPage"
          :page="page"
          :server-items-length="totalItems"
          :footer-props="footerProps"
          :loading="loading"
          :loading-text="$t('Carregando')"
          :no-data-text="$t('Nenhum_registro_encontrado')"
          show-select
          item-key="id"
          :single-select="true"
          class="table tabela-seleciona-pessoa__tabela"
          @update:page="onPageChange"
          @update:items-per-page="onItemsPerPageChange"
        >
          <template v-slot:[`item.cpf`]="{ item }">
            <span>{{ item.cpf | VMask("###.###.###-##") }}</span>
          </template>

          <template v-slot:[`item.actions`]="{ item }">
            <v-icon small class="mr-2" @click="editPessoa(item.id)"
              >ni-ruler-pencil</v-icon
            >
          </template>

          <template v-slot:no-data>
            <div class="tabela-seleciona-pessoa__estado-vazio">
              <v-icon size="38" color="#adb5bd">
                mdi-account-search-outline
              </v-icon>
              <strong>{{ $t("Nenhum_registro_encontrado") }}</strong>
              <span>{{ $t("Nome e CPF") }}</span>
            </div>
          </template>
        </v-data-table>

        <div v-else class="tabela-seleciona-pessoa__estado-inicial">
          <v-icon size="42" color="#adb5bd">
            mdi-account-search-outline
          </v-icon>
          <div>
            <strong>{{ $t("Procurar") }}</strong>
            <span>{{ $t("Nome e CPF") }}</span>
          </div>
        </div>

        <v-card-actions class="tabela-seleciona-pessoa__rodape">
          <v-btn
            to="/dashboard/pessoas/cadastro"
            v-can="'ROLE_Pessoa_Insert'"
            class="
              tabela-seleciona-pessoa__botao-cadastro
              ma-0
              font-weight-bold
              text-none
              btn-primary
              bg-gradient-primary
              py-3
              px-6
            "
            height="39"
          >
            <v-icon left dark size="18">mdi-account-plus-outline</v-icon>
            {{ $t("Cadastrar_pessoa") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import DataService from "@/services/pessoal/PessoaDataService";
import { translateIfMessageExists } from "@/utils/i18n";

export default {
  name: "TabelaSelecionaPessoa",

  props: {
    titulo: { type: String, required: false, default: "Pessoa" },
    payload: {
      type: Object,
      default() {
        return {};
      },
    },
    editar: { type: Boolean, default: false },
    carregarPessoas: { type: Function, required: false, default: null },
  },

  data() {
    return {
      itemsPerPage: 4,

      idEditado: "",
      formEditPessoa: false,
      pessoas: [],
      pessoa: [],
      filters: {
        nomeCpf: "",
      },
      loading: false,
      searched: false,
      errorMessage: "",
      searchRequestId: 0,
      totalItems: 0,
      page: 1,
      headers: [
        { text: this.$t("Nome"), value: "nome", sortable: "false" },
        { text: this.$t("CPF"), value: "cpf", sortable: "false" },
      ],
    };
  },

  mounted() {
    if (this.editar) {
      this.itemsPerPage = 1;
    }

    if (this.payload && this.payload.id) {
      this.carregarPessoaInicial();
    }
  },

  beforeDestroy() {
    this.searchRequestId += 1;
  },

  computed: {
    translatedTitle() {
      return translateIfMessageExists(this.$i18n, this.titulo);
    },
    hasFilters() {
      return Boolean(String(this.filters.nomeCpf || "").trim());
    },
    showResultCount() {
      return this.searched && !this.loading;
    },
    footerProps() {
      return {
        itemsPerPageOptions: this.editar ? [1, 4, 8, 16] : [4, 8, 16],
      };
    },
    pessoaSelecionada() {
      const selecionada = Array.isArray(this.pessoa) ? this.pessoa[0] : null;
      if (!selecionada || !selecionada.nome) return null;
      return selecionada;
    },
    iniciaisPessoaSelecionada() {
      if (!this.pessoaSelecionada) return "";
      const partes = String(this.pessoaSelecionada.nome)
        .trim()
        .split(/\s+/)
        .filter(Boolean);
      if (!partes.length) return "";
      const primeira = partes[0].charAt(0);
      const ultima =
        partes.length > 1 ? partes[partes.length - 1].charAt(0) : "";
      return `${primeira}${ultima}`.toLocaleUpperCase("pt-BR");
    },
  },

  methods: {
    onSearchShortcut(event) {
      const key = String(event?.key || "");
      const ctrlOrCmd = Boolean(event && (event.ctrlKey || event.metaKey));
      const isSearchShortcut = Boolean(
        event &&
          key === "Enter" &&
          ctrlOrCmd &&
          event.shiftKey &&
          !event.altKey &&
          !event.repeat
      );

      if (!isSearchShortcut) return;

      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === "function") {
        event.stopImmediatePropagation();
      }
      if (!this.loading && this.hasFilters) this.onSearch();
    },

    async onSearch(resetPage = true) {
      if (!this.hasFilters) return;
      if (resetPage) this.page = 1;

      const requestId = (this.searchRequestId += 1);
      this.loading = true;
      this.searched = true;
      this.errorMessage = "";

      const payload = {
        nomeCpf: String(this.filters.nomeCpf || "").trim(),
      };
      const params = {
        page: Math.max(Number(this.page) - 1, 0),
        linesPerPage: this.itemsPerPage,
        orderBy: "nome",
        direction: "ASC",
      };

      try {
        const response = await this.fetchPessoas(payload, params);
        if (requestId !== this.searchRequestId) return;

        const resultado = this.normalizeResult(response);
        this.pessoas = resultado.items;
        this.totalItems = resultado.total;
      } catch (error) {
        if (requestId !== this.searchRequestId) return;
        this.pessoas = [];
        this.totalItems = 0;
        this.errorMessage = this.$t("Erro_ao_carregar");
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
        console.error("Erro ao buscar pessoas:", error);
        this.$emit("error", error);
      } finally {
        if (requestId === this.searchRequestId) {
          this.loading = false;
        }
      }
    },

    getPessoas(resetPage = true) {
      return this.onSearch(resetPage);
    },

    fetchPessoas(payload, params) {
      if (this.carregarPessoas) {
        return this.carregarPessoas(payload, params);
      }
      return DataService.getFilterPage(payload, params);
    },

    normalizeResult(response) {
      const data =
        response && response.data !== undefined ? response.data : response;

      if (Array.isArray(data)) {
        const inicio = (this.page - 1) * this.itemsPerPage;
        return {
          items: data.slice(inicio, inicio + this.itemsPerPage),
          total: data.length,
        };
      }

      if (data && Array.isArray(data.content)) {
        return {
          items: data.content,
          total: Number(data.totalElements || data.content.length),
        };
      }

      return { items: [], total: 0 };
    },

    async carregarPessoaInicial() {
      const requestId = (this.searchRequestId += 1);
      this.loading = true;
      this.searched = true;
      this.errorMessage = "";

      try {
        const response = await DataService.find(this.payload.id);
        if (requestId !== this.searchRequestId) return;
        const selecionada =
          response && response.data ? response.data : response;
        if (!selecionada || !selecionada.id) return;

        this.pessoas = [selecionada];
        this.totalItems = 1;
        this.pessoa = [selecionada];
        this.filters.nomeCpf = selecionada.nome || selecionada.cpf || "";
      } catch (error) {
        if (requestId !== this.searchRequestId) return;
        this.pessoas = [];
        this.totalItems = 0;
        this.errorMessage = this.$t("Erro_ao_carregar");
        console.error("Erro ao carregar pessoa selecionada:", error);
        this.$emit("error", error);
      } finally {
        if (requestId === this.searchRequestId) {
          this.loading = false;
        }
      }
    },

    onClear() {
      this.searchRequestId += 1;
      this.filters.nomeCpf = "";
      this.pessoas = [];
      this.totalItems = 0;
      this.page = 1;
      this.searched = false;
      this.errorMessage = "";
      this.$emit("cleared");
      this.$nextTick(() => {
        const input = this.$refs.nomeCpfInput;
        if (input && typeof input.focus === "function") input.focus();
      });
    },

    onPageChange(value) {
      const nextPage = Math.max(Number(value) || 1, 1);
      if (nextPage === this.page) return;
      this.page = nextPage;
      if (this.searched && this.hasFilters) this.onSearch(false);
    },

    onItemsPerPageChange(value) {
      const nextSize = Number(value);
      if (!Number.isFinite(nextSize) || nextSize <= 0) return;
      if (nextSize === this.itemsPerPage) return;
      this.itemsPerPage = nextSize;
      this.page = 1;
      if (this.searched && this.hasFilters) this.onSearch(false);
    },

    onModoEdicaoChange() {
      this.page = 1;
      if (this.searched && this.hasFilters) this.onSearch(false);
    },
    editPessoa(id) {
      this.idEditado = id;
      this.formEditPessoa = true;
    },
  },

  watch: {
    pessoa: function (newValue) {
      if (Array.isArray(newValue) && newValue.length > 0) {
        this.$emit("pessoa", { id: newValue[0].id });
      }
    },
  },
};
</script>

<style scoped>
.tabela-seleciona-pessoa__layout {
  margin: 0;
}

.tabela-seleciona-pessoa__coluna {
  padding: 0;
}

.tabela-seleciona-pessoa,
.tabela-seleciona-pessoa__dialogo {
  overflow: hidden;
  border-color: #e9ecef !important;
  border-radius: 14px;
  background: #fff;
}

.tabela-seleciona-pessoa__cabecalho {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 14px 20px 12px;
  border-bottom: 1px solid #f0f2f5;
  background: linear-gradient(135deg, #fff 0%, #f8f9fa 100%);
}

.tabela-seleciona-pessoa__identificacao {
  display: flex;
  align-items: center;
  min-width: 0;
}

.tabela-seleciona-pessoa__icone {
  flex: 0 0 auto;
  margin-right: 12px;
  background: rgba(94, 114, 228, 0.1);
}

.tabela-seleciona-pessoa__indicadores {
  display: flex;
  flex: 0 0 auto;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 8px;
}

.tabela-seleciona-pessoa__filtros {
  margin: 8px 20px 12px;
  padding: 6px 8px;
  border: 1px solid #edf0f5;
  border-radius: 12px;
  background: #f8f9fa;
}

.tabela-seleciona-pessoa__campos {
  margin: -4px;
}

.tabela-seleciona-pessoa__campos > .col {
  padding: 8px;
}

.tabela-seleciona-pessoa__modo-edicao {
  display: flex;
  align-items: center;
}

.tabela-seleciona-pessoa__acoes-busca {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
}

.tabela-seleciona-pessoa__botao-busca {
  margin: 0;
}

.tabela-seleciona-pessoa__dica {
  display: flex;
  align-items: center;
  margin: 0 8px 2px;
  color: #8392ab;
  font-size: 0.75rem;
}

.tabela-seleciona-pessoa__erro {
  margin: 0 20px 12px;
}

.tabela-seleciona-pessoa__selecionada {
  display: flex;
  align-items: center;
  gap: 11px;
  margin: 0 20px 12px;
  padding: 10px 12px;
  border: 1px solid rgba(76, 175, 80, 0.24);
  border-left: 3px solid #4caf50;
  border-radius: 10px;
  background: linear-gradient(
    135deg,
    rgba(76, 175, 80, 0.07) 0%,
    rgba(255, 255, 255, 0.96) 72%
  );
  box-shadow: 0 2px 7px rgba(50, 71, 103, 0.05);
}

.tabela-seleciona-pessoa__selecionada-avatar {
  position: relative;
  flex: 0 0 auto;
}

.tabela-seleciona-pessoa__selecionada-avatar .v-avatar {
  color: #4f60c7;
  font-size: 0.8rem;
  font-weight: 800;
  letter-spacing: 0.02em;
  background: rgba(94, 114, 228, 0.12);
}

.tabela-seleciona-pessoa__selecionada-check {
  position: absolute;
  right: -2px;
  bottom: -1px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 17px;
  height: 17px;
  border: 2px solid #fff;
  border-radius: 50%;
  background: #4caf50;
}

.tabela-seleciona-pessoa__selecionada-conteudo {
  min-width: 0;
  margin-right: auto;
}

.tabela-seleciona-pessoa__selecionada-conteudo strong {
  display: block;
  overflow: hidden;
  color: #344767;
  font-size: 0.875rem;
  line-height: 1.25;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.tabela-seleciona-pessoa__selecionada-conteudo span {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 4px;
  color: #8392ab;
  font-size: 0.75rem;
  line-height: 1.2;
}

.tabela-seleciona-pessoa__selecionada-conteudo .v-icon {
  color: #8392ab;
}

.tabela-seleciona-pessoa__tabela {
  margin: 0 20px 12px;
  border: 1px solid #edf0f5;
  border-radius: 10px;
}

.tabela-seleciona-pessoa__tabela::v-deep .v-data-table__wrapper {
  border-radius: 10px 10px 0 0;
}

.tabela-seleciona-pessoa__tabela::v-deep thead th {
  color: #67748e !important;
  font-size: 0.75rem;
  letter-spacing: 0.025em;
  background: #f8f9fa;
}

.tabela-seleciona-pessoa__tabela::v-deep tbody tr {
  transition: background-color 0.2s ease;
}

.tabela-seleciona-pessoa__tabela::v-deep tbody tr:hover,
.tabela-seleciona-pessoa__tabela::v-deep tr.v-data-table__selected {
  background: rgba(94, 114, 228, 0.055) !important;
}

.tabela-seleciona-pessoa__tabela::v-deep .v-data-footer {
  border-top-color: #edf0f5;
}

.tabela-seleciona-pessoa__estado-inicial,
.tabela-seleciona-pessoa__estado-vazio {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
  color: #8392ab;
}

.tabela-seleciona-pessoa__estado-inicial {
  min-height: 112px;
  margin: 0 20px 12px;
  padding: 20px;
  border: 1px dashed #d9dee7;
  border-radius: 12px;
  background: #fbfcfd;
}

.tabela-seleciona-pessoa__estado-vazio {
  min-height: 130px;
  flex-direction: column;
  gap: 5px;
  padding: 24px;
  text-align: center;
}

.tabela-seleciona-pessoa__estado-inicial strong,
.tabela-seleciona-pessoa__estado-inicial span {
  display: block;
}

.tabela-seleciona-pessoa__estado-inicial strong,
.tabela-seleciona-pessoa__estado-vazio strong {
  color: #344767;
}

.tabela-seleciona-pessoa__rodape {
  justify-content: flex-end;
  padding: 0 20px 20px;
}

.tabela-seleciona-pessoa__dialogo-titulo {
  display: flex;
  align-items: center;
  color: #344767;
  font-size: 1.125rem;
  font-weight: 700;
}

.tabela-seleciona-pessoa__dialogo-acoes {
  padding: 8px 24px 20px;
}

.min-width-0 {
  min-width: 0;
}

@media (max-width: 600px) {
  .tabela-seleciona-pessoa__cabecalho {
    align-items: stretch;
    flex-direction: column;
  }

  .tabela-seleciona-pessoa__cabecalho {
    padding: 16px;
  }

  .tabela-seleciona-pessoa__filtros {
    margin-right: 0;
    margin-left: 0;
    border-right: 0;
    border-left: 0;
    border-radius: 0;
  }

  .tabela-seleciona-pessoa__indicadores {
    justify-content: flex-start;
  }

  .tabela-seleciona-pessoa__acoes-busca {
    align-items: stretch;
    flex-direction: column;
  }

  .tabela-seleciona-pessoa__botao-busca {
    width: 100%;
  }

  .tabela-seleciona-pessoa__erro,
  .tabela-seleciona-pessoa__selecionada,
  .tabela-seleciona-pessoa__tabela,
  .tabela-seleciona-pessoa__estado-inicial {
    margin-right: 12px;
    margin-left: 12px;
  }

  .tabela-seleciona-pessoa__estado-inicial {
    align-items: center;
    flex-direction: column;
    text-align: center;
  }

  .tabela-seleciona-pessoa__selecionada {
    align-items: flex-start;
    flex-wrap: wrap;
  }

  .tabela-seleciona-pessoa__selecionada .v-chip {
    margin-left: 51px;
  }

  .tabela-seleciona-pessoa__rodape {
    padding-right: 12px;
    padding-left: 12px;
  }

  .tabela-seleciona-pessoa__botao-cadastro {
    width: 100%;
  }
}
</style>
